import { render, staticRenderFns } from "./ResubmissionTFASuccess.vue?vue&type=template&id=473af946"
import script from "./ResubmissionTFASuccess.vue?vue&type=script&lang=js"
export * from "./ResubmissionTFASuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports